import React, { ComponentProps } from 'react';
import { TFunction } from 'i18next';
import { asView } from '../../../_lib/ViewFetcher';
import { ContentList, ContentListItem } from '../../../_lib/components/ContentList';
import { murmurhash } from '../../../lib/js/hash';
import ILink from '../../../types/ILink';
import { ContentLink } from '../../../_lib/components/ContentLink';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { getItemHelpText, getTarget, getUrlProtocol } from '../../../components/atoms/Hyperlink/Hyperlink.utils';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

export type ExternalLinksDefaultViewProps = { items?: ILink[] };

export function ExternalLinksDefault({ items }: ExternalLinksDefaultViewProps) {
  const { t } = useSonTranslation('phrases');

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <ContentList>
      {items.map((item, index) => (
        <ContentListItem key={murmurhash(item.url + index)}>
          <ContentLink
            to={item.url}
            external={item.external}
            newWindowIndicator
            target={getTarget(item.url)}
            title={getItemHelpText(getUrlProtocol(item.url), t as TFunction)}
            tooltipPlacement={TooltipPlacement.BOTTOM}
          >
            {item.name || item.url}
          </ContentLink>
        </ContentListItem>
      ))}
    </ContentList>
  );
}
export const ExternalLinksDefaultView = asView(ExternalLinksDefault);
export type ExternalLinksDefaultView = ComponentProps<typeof ExternalLinksDefaultView>;
